import { Typography } from "@mui/material";
import { assoc } from "ramda";
import React, { useEffect, useRef, useState } from "react";
import Dialog from "@hyro-components/Dialogs/HyroUiDialog";

import DraftButtons from "./DraftButtons";
import { REFRESH_PAGE } from "./DraftHeaderConsts";
import PortalTextContent from "./header-text-content/HeaderTextContent";
import useDraftPublishHeader from "./useDraftPublishHeader";
import { DIALOG_VARIANTS } from "@hyro-components/Dialogs/DialogConsts";
import StatusBar from "@hyro-components/StatusBar";
import HyroFeedbackMessage from "@hyro-components/HyroFeedbackMessage";
import useAppStore from "../../../../../stores/appStore";
import { isAssistantPreviewableSelector, isReadOnlyModeSelector } from "../../../../../stores/selectors/appSelectors";
import { isUpdatingCollectionSelector } from "../../../../../stores/selectors/collectionsSelectors";
import {
  isPublishingTripletsSelector,
  isSavingTripletsSelector
} from "../../../../../stores/selectors/tripletsSelectors";
import { SEVERITY_VARIANTS } from "@consts";
import { useDraft } from "src/queries/hooks/assistants";

const DraftPublishHeader = () => {
  const isPublishingTriplets = useAppStore(isPublishingTripletsSelector);
  const isUpdatingCollection = useAppStore(isUpdatingCollectionSelector);
  const isSavingTriplets = useAppStore(isSavingTripletsSelector);
  const { data: draft } = useDraft();
  const isReadOnly = useAppStore(isReadOnlyModeSelector);
  const isAssistantPreviewable = useAppStore(isAssistantPreviewableSelector);

  const [snackbarAlert, setSnackbarAlert] = useState({
    open: false,
    message: "",
    severity: ""
  });
  const headerRef = useRef();
  const inProgressOrTestIsRunning
    = isSavingTriplets
    || isPublishingTriplets
    || isUpdatingCollection;

  const displayPreviewButtons = isAssistantPreviewable && !isReadOnly;

  useEffect(() => {
    if (isSavingTriplets) {
      setSnackbarAlert({
        open: true,
        message: "Saving changes",
        severity: SEVERITY_VARIANTS.SUCCESS
      });
    }
  }, [setSnackbarAlert, isSavingTriplets]);

  const handleCloseSnackbar = setSnackbarAlert =>
    setSnackbarAlert(assoc("open", false));

  const draftErrorsDialog = useDraftPublishHeader();

  if (draftErrorsDialog.open) {
    return (
      <Dialog
        open={draftErrorsDialog.open}
        title={draftErrorsDialog.title}
        submitButtonText={REFRESH_PAGE}
        handleSubmit={() => location.reload()}
        handleCancel={draftErrorsDialog.handleCancel}
        variant={DIALOG_VARIANTS.transactional}
      >
        <Typography>{draftErrorsDialog.text}</Typography>
      </Dialog>
    );
  }

  return draft || isReadOnly
    ? (
      <>
        <StatusBar
          isReadOnly={isReadOnly}
          mobileChildren={
            <>
              {isReadOnly
                ? "Read only mode"
                : "Draft mode - please open on a larger screen"}
            </>}
          headerRef={headerRef}
        >
          <PortalTextContent {...{ isSavingTriplets, isReadOnly }} />
          {!isReadOnly && (
            <DraftButtons
              inProgressOrTestIsRunning={inProgressOrTestIsRunning}
              displayPreviewButtons={displayPreviewButtons}
              setSnackbarAlert={setSnackbarAlert}
            />
          )}
        </StatusBar>
        <HyroFeedbackMessage
          showFeedback={snackbarAlert.open}
          closeFeedback={() => handleCloseSnackbar(setSnackbarAlert)}
          message={snackbarAlert.message}
          severity={snackbarAlert.severity}
        />
      </>
    )
    : null;
};

export default DraftPublishHeader;
